import React from 'react';

function ShuffleIcon() {
	return (
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
			<path d="M95,72.8l-10.5-6.2l-10.1-6.2C73.8,60,73,60.5,73,61.3v5.4c-7-1.1-12.3-5.5-16.9-11.5
				c-0.5,0.8-1.1,1.5-1.6,2.3c-1.7,2.6-3.4,5.3-5.4,8C55,72.4,62,77.8,73,78.8v7.2c0,0.8,0.8,1.2,1.4,0.9l10.3-6.2L95,74.5
				C95.7,74.1,95.7,73.2,95,72.8z" />
			<path d="M12.5,19H9.1C7.9,19,7,19.9,7,21.1v7.8C7,30.1,7.9,31,9.1,31h3.4c9.8,0,15.9,5.7,21.7,13.7
				c0-0.1,0.1-0.1,0.1-0.2c2.2-3.3,4.5-6.8,7-10.2C34.6,25.8,25.9,19,12.5,19z" />
			<path d="M95,25.4L84.2,19l-10.7-6.4c-0.7-0.4-1.6,0.1-1.6,0.9v7.8C55.7,23.2,47,36,39.4,47.7
				C31.8,59.4,25.2,69,12.5,69H9.1C7.9,69,7,69.9,7,71.1v7.8C7,80.1,7.9,81,9.1,81h3.4c19.2,0,28.6-14,36.9-26.7
				C56.1,44,62,35.3,72,33.4v5.8c0,0.8,0.9,1.3,1.6,0.9l10.5-6.4L95,27.2C95.7,26.8,95.7,25.8,95,25.4z" />
		</svg>
	);
}

function Bag() {
	return (
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 57">
			<path d="M41.0200882,19.2628937c-0.017395-3.9971924-0.9837646-9.9161987-4.2613525-14.1099854
				c-2.5493164-3.262207-6.0966797-4.9863281-10.2587891-4.9863281c-4.1738281,0-7.7285156,1.7387695-10.2802734,5.0288086
				c-3.2485962,4.1885381-4.208374,10.1835327-4.2262573,14.1690674L0.4915235,19.4046783l3.3200073,37.4310303h45.3779907
				l3.3189697-37.6130371L41.0200882,19.2628937z M22.6688919,9.9390411c1.012207-1.2260742,2.1938477-1.7724609,3.8310547-1.7724609
				c1.6484375,0,2.8354492,0.5493164,3.8496094,1.7802734c2.0596313,2.5014648,2.6561279,6.8780518,2.6860962,9.3439331
				l-13.0667725,0.0457153C19.9942703,16.8578644,20.5958939,12.449234,22.6688919,9.9390411z" />
		</svg>
	);
}

function House() {
	const style = {
		fillRule: 'evenodd',
		clipRule: 'evenodd',
	};
	return (
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 57">
			<path style={style} d="M60.9744568,25.0246086L30.5041218,0.1654159L0.0318311,25.023571
				l6.3676362,7.1027603l1.5725493,24.7082138h10.932312l-0.5641479-12.3484497
				c0-6.7147217,5.4432373-12.1588745,12.1588745-12.1588745s12.1588726,5.4441528,12.1588726,12.1588745l-0.5197144,12.3484497
				h10.895813l1.5645981-24.7002029L60.9744568,25.0246086z" />
		</svg>
	);
}

function Camera() {
	const style = {
		fillRule: 'evenodd',
		clipRule: 'evenodd',
	};
	return (
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63 49">
			<path style={style} d="M23.7393856,18.3074722c4.8624401,0,8.8047771,3.9423485,8.8047771,8.804781
				c0,4.8624401-3.942337,8.8047886-8.8047771,8.8047886s-8.804781-3.9423485-8.804781-8.8047886
				C14.9346046,22.2498207,18.8769417,18.3074722,23.7393856,18.3074722" />
			<path style={style} d="M53.1467819,6.5267105H39.1017838l0.0277214-0.0017486l-3.2673225-4.0041676
				c-1.2044563-1.4760207-3.23209-2.3626046-5.4033775-2.3626046H16.6289635c-2.1712847,0-4.1989193,0.8865839-5.4033108,2.3626046
				L7.9582648,6.5249619l0.0236397,0.0017486H5.2673607c-2.6465397,0-4.8333044,2.1867647-4.8333044,4.8333044v32.6484261
				c0,2.6466026,2.1867647,4.8333702,4.8338871,4.8333702h47.8793526c2.6466064,0,4.8333702-2.1867676,4.8333702-4.8333702
				V11.3600149C57.9806671,8.7134752,55.7939034,6.5267105,53.1467819,6.5267105z M23.7393818,42.5024338
				c-8.4997168,0-15.3901234-6.8904076-15.3901234-15.3908348c0-8.4990044,6.8904066-15.3894119,15.3901234-15.3894119
				s15.3901234,6.8904076,15.3901234,15.3894119C39.1295052,35.6120262,32.2390976,42.5024338,23.7393818,42.5024338z
				 M47.2482033,21.4514885c-2.4386406,0-4.4155655-1.9769859-4.4155655-4.4156265
				c0-2.4387045,1.9769249-4.4156275,4.4155655-4.4156275c2.4387054,0,4.4156265,1.976923,4.4156265,4.4156275
				C51.6638298,19.4745026,49.6869087,21.4514885,47.2482033,21.4514885z" />
			<g className="snapshot-flash">
				<path style={style} fill="#FFFFFF" d="M48.8290253,3.7666812l2.5763054-1.1934686
					C53.297596,1.696642,55.5194092,2.7667944,56.01408,4.7925673l0.6731491,2.7582936
					c0.2308235,0.9450812,0.8656769,1.7411942,1.7355728,2.1764894l2.5394173,1.2700605
					c1.8648605,0.933136,2.4136391,3.3372889,1.1379585,4.987134l-1.7366257,2.2460556
					c-0.5951576,0.769762-0.8214149,1.76227-0.6193962,2.7136745l0.5902367,2.7772675
					c0.4331856,2.0401726-1.1042328,3.9679222-3.1893806,3.9995441l-2.8390961,0.042511
					c-0.9724846,0.0147533-1.8898087,0.4563751-2.5077972,1.2075214l-1.8033829,2.1930046
					c-1.3245125,1.6108475-3.7905006,1.6108475-5.1150131,0l-1.80373-2.1930046
					c-0.6176414-0.7511463-1.5349655-1.1927681-2.5077972-1.2075214l-2.8387527-0.042511
					c-2.085495-0.0316219-3.6229134-1.9593716-3.189373-3.9995441l0.5902328-2.7772675
					c0.2020149-0.9514046-0.0245934-1.9439125-0.6193924-2.7136745l-1.7369766-2.2460556
					c-1.2756824-1.6498451-0.7269058-4.053998,1.1383095-4.987134l2.5394135-1.2700605
					c0.8702469-0.4352951,1.5047493-1.2314081,1.7352219-2.1764894l0.6735001-2.7582936
					c0.4946709-2.0257728,2.7164879-3.0959253,4.6087494-2.2193546l2.5763054,1.1934686
					C46.9283295,4.1756325,47.9461288,4.1756325,48.8290253,3.7666812" />
			</g>
		</svg>
	);
}

function ShopBox() {
	return (
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112.9 114.3">
			<g>
				<path d="M62,30.7H43.5c-11.6,0-16.9-7.6-16.9-14.7c0-8.1,6.6-14.7,14.7-14.7c7.4,0,13.5,4.5,17.2,12.6
					c2.4,5.5,3,11,3,11.2L62,30.7z M41.2,11.4c-2.6,0-4.7,2.1-4.7,4.7c0,4.3,5.3,4.7,6.9,4.7h6.8C48.9,16.5,46.3,11.4,41.2,11.4z"/>
			</g>
			<g>
				<path d="M69.5,30.7H50.9l0.6-5.5c0-0.2,0.6-5.7,3-11.2c3.6-8.2,9.7-12.6,17.2-12.6c8.1,0,14.7,6.6,14.7,14.7
					C86.4,23.1,81.1,30.7,69.5,30.7z M62.7,20.7h6.8c1.6,0,6.9-0.3,6.9-4.7c0-2.6-2.1-4.7-4.7-4.7C66.6,11.4,64,16.5,62.7,20.7z"/>
			</g>
			<g>
				<rect x="7.9" y="41.2" width="43.6" height="21.4"/>
				<rect x="61.5" y="41.2" width="43.6" height="21.4"/>
			</g>
			<g>
				<polygon points="51.5,72.5 15.4,72.5 18.8,114.3 51.5,114.3 	"/>
				<polygon points="61.5,72.5 61.5,114.3 94.1,114.3 97.5,72.5 	"/>
			</g>
		</svg>
	);
}

function Badge({ classes }) {
	const style = {
		fillRule: 'evenodd',
		clipRule: 'evenodd',
	};
	return (
		<svg className={classes} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
			<path style={style} d="M32.7194595,3.5239437l5.0332947-2.331665
				c3.6968956-1.7125453,8.0376244,0.3781986,9.0040588,4.3359256l1.3151207,5.388845
				c0.4509621,1.8463926,1.6912651,3.4017506,3.39077,4.2521811l4.9612274,2.4813013
				c3.6433563,1.8230553,4.7154961,6.5200195,2.2232132,9.7433033l-3.3928223,4.3880901
				c-1.1627502,1.5038757-1.6047821,3.4429283-1.2101059,5.3016739l1.1531372,5.4259148
				c0.8463135,3.9858589-2.1573257,7.752079-6.2310524,7.813858l-5.546711,0.0830574
				c-1.899929,0.02882-3.6920929,0.891613-4.8994484,2.3591156l-3.5232468,4.2844467
				c-2.5876846,3.1470947-7.4054546,3.1470947-9.9931412,0l-3.5239277-4.2844467
				c-1.2066746-1.4675026-2.9988365-2.3302956-4.8994484-2.3591156l-5.5460329-0.0830574
				c-4.0744071-0.061779-7.0780487-3.8279991-6.2310443-7.813858l1.1531348-5.4259148
				c0.3946743-1.8587456-0.0480471-3.7977982-1.2101045-5.3016739l-3.3935113-4.3880901
				c-2.4922814-3.2232838-1.4201401-7.920248,2.2239027-9.7433033l4.9612255-2.4813013
				c1.7001896-0.8504305,2.9398041-2.4057884,3.3900824-4.2521811l1.3158064-5.388845
				c0.9664345-3.957727,5.3071661-6.048471,9.0040579-4.3359256l5.0332947,2.331665
				C29.0060902,4.322907,30.9945583,4.322907,32.7194595,3.5239437" />
		</svg>
	);
}
Badge.defaultProps = {
	classes: '',
};

function PriceBadgeSVG() {
	const style = {
		fillRule: 'evenodd',
		clipRule: 'evenodd',
	};
	return (
		<svg className="price-badge__svg" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
			<path className="price-badge__svg__badge" style={style} d="M32.7194595,3.5239437l5.0332947-2.331665
				c3.6968956-1.7125453,8.0376244,0.3781986,9.0040588,4.3359256l1.3151207,5.388845
				c0.4509621,1.8463926,1.6912651,3.4017506,3.39077,4.2521811l4.9612274,2.4813013
				c3.6433563,1.8230553,4.7154961,6.5200195,2.2232132,9.7433033l-3.3928223,4.3880901
				c-1.1627502,1.5038757-1.6047821,3.4429283-1.2101059,5.3016739l1.1531372,5.4259148
				c0.8463135,3.9858589-2.1573257,7.752079-6.2310524,7.813858l-5.546711,0.0830574
				c-1.899929,0.02882-3.6920929,0.891613-4.8994484,2.3591156l-3.5232468,4.2844467
				c-2.5876846,3.1470947-7.4054546,3.1470947-9.9931412,0l-3.5239277-4.2844467
				c-1.2066746-1.4675026-2.9988365-2.3302956-4.8994484-2.3591156l-5.5460329-0.0830574
				c-4.0744071-0.061779-7.0780487-3.8279991-6.2310443-7.813858l1.1531348-5.4259148
				c0.3946743-1.8587456-0.0480471-3.7977982-1.2101045-5.3016739l-3.3935113-4.3880901
				c-2.4922814-3.2232838-1.4201401-7.920248,2.2239027-9.7433033l4.9612255-2.4813013
				c1.7001896-0.8504305,2.9398041-2.4057884,3.3900824-4.2521811l1.3158064-5.388845
				c0.9664345-3.957727,5.3071661-6.048471,9.0040579-4.3359256l5.0332947,2.331665
				C29.0060902,4.322907,30.9945583,4.322907,32.7194595,3.5239437" />
			<g className="price-badge__svg__ellipsis">
				<circle cx="18.4795742" cy="30" r="2.7578125" />
				<circle cx="30" cy="30" r="2.7578125" />
				<circle cx="41.5204239" cy="30" r="2.7578125" />
			</g>
			<g className="price-badge__svg__checkmark">
				<polygon fill="#FFFFFF" points="27.2325401,39.7163086 18.6383018,31.121582 22.1744347,27.5864258 27.2325401,32.6450195
					37.8262901,22.0517578 41.3614464,25.5869141 " />
			</g>
			<g className="price-badge__svg__offline-face">
				<polygon points="42.7232857,18.2530651 40.279438,18.2530651 42.7232857,14.747694 42.7232857,12.8526745 36.9850044,12.8526745
					36.9850044,15.1754284 39.317524,15.1754284 36.958149,18.6837292 36.958149,20.575819 42.7232857,20.575819 " />
				<polygon points="34.9098091,24.1495495 32.4659615,24.1495495 34.9098091,20.6441784 34.9098091,18.7491589
					29.1715279,18.7491589 29.1715279,21.0719128 31.5040474,21.0719128 29.1446724,24.5802135 29.1446724,26.4723034
					34.9098091,26.4723034 " />
				<circle cx="30.0000191" cy="39.8555412" r="2.7578125" />
				<path d="M44.4181099,32.2667351c-1.019043,1.2397461-2.5219727,1.9506836-4.1245117,1.9506836
					s-3.105957-0.7109375-4.1245117-1.9511719l-2.3183594,1.9042969c1.5908203,1.9365234,3.9389648,3.046875,6.4428711,3.046875
					c2.503418,0,4.8515625-1.1103516,6.4418945-3.0463867L44.4181099,32.2667351z" />
				<path d="M19.7066841,34.2174187c-1.6025391,0-3.105957-0.7109375-4.1245127-1.9511719l-2.3183594,1.9042969
					c1.5908203,1.9365234,3.9389658,3.046875,6.442872,3.046875c2.503418,0,4.8520508-1.1103516,6.4423828-3.0463867
					l-2.3173828-1.9042969C22.8126411,33.5064812,21.3092232,34.2174187,19.7066841,34.2174187z" />
			</g>
		</svg>
	);
}

function X() {
	return (
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
			<polygon points="53.8842773,13.1870413 46.8129883,6.1157522 30,22.9287415 13.1870117,6.1157522 6.1157227,13.1870413
				22.9287109,30.0000305 6.1157227,46.8130188 13.1870117,53.8843079 30,37.0713196 46.8129883,53.8843079 53.8842773,46.8130188
				37.0712891,30.0000305 	" />
		</svg>
	);
}

export { ShuffleIcon, Bag, House, Camera, ShopBox, Badge, PriceBadgeSVG, X };



// WEBPACK FOOTER //
// ./src/components/Global/Icons/index.js